var n = /* @__PURE__ */ ((r) => (r.DROPDOWN = "dropdown", r.INLINE_LIST = "inline-list", r))(n || {});
export {
  n as RocheUILanguageSwitchLayoutType
};
